import { inject, Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { AppState, RoleConstants } from 'src/app/models';
import { UserInfo } from 'src/app/models/users/user.models';

@Injectable({
  providedIn: 'root'
})

export class UserRoleService implements OnDestroy{

  private userDestroyed$:                                                      Subject<void> = new Subject<void>();
  private user:                                                                UserInfo = {};
  
  /* 
  * Injections
  */
  private store:                                                               Store<AppState> = inject(Store<AppState>);
  

  getUserInfo(){
  
    this.store.select(appState => appState.User).pipe( takeUntil(this.userDestroyed$) ).subscribe(( user: UserInfo ) => {

      this.user = user;
    })
  }

  checkUserRole():{isAdmin:boolean,isContributor:boolean,isReader:boolean} | undefined{

    this.getUserInfo();
    
    let userRoles : {isAdmin:boolean,isContributor:boolean,isReader:boolean} = {
      
      isAdmin : false,
      isContributor : false,
      isReader : false
    }

    const { idTokenClaims } = this.user || {};

    let { roles } = idTokenClaims || {};

    if( !roles ) return userRoles; // all seted to false

    roles = roles.map(( r:string ) => r.toLowerCase());

    userRoles.isAdmin = Boolean(roles.find(e => e === RoleConstants.ADMIN.toLowerCase()));
    userRoles.isContributor = Boolean(roles.find(e => e === RoleConstants.CONTRIBUTOR.toLowerCase()));
    userRoles.isReader = Boolean(roles.find(e => e === RoleConstants.READER.toLowerCase()));

    return userRoles;
  }

  ngOnDestroy(): void {

    this.userDestroyed$.next();
    this.userDestroyed$.complete();
  }
}
